import { Dropdown, Popconfirm } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useState } from 'react';

interface MenuProps {
    onDelete: () => void;
    onClose: () => void;
    onDefaultClick: () => void;
    onUpdate: () => void;
    isOwner: boolean;
}

const Menu = ({ onDelete, onDefaultClick, onClose, onUpdate, isOwner }: MenuProps) => {
    const handleRemoveClick = () => {
        onDelete();
        onClose();
    };

    const handleDefaultClick = () => {
        onDefaultClick();
        onClose();
    };

    const handleUpdateClick = () => {
        onUpdate();
        onClose();
    };

    return (
        <ul className="rounded border border-gray-500 bg-white text-right text-xs text-black dark:border-fill-primary dark:bg-block-secondary dark:text-gray-1300">
            <li>
                <div role="button" className="px-4 pb-2 pt-2" onClick={handleDefaultClick}>
                    Сделать шаблоном по умолчанию
                </div>
            </li>
            {isOwner && (
                <>
                    <li className="border-b border-solid border-gray-500 dark:border-fill-primary">
                        <Popconfirm
                            title="Перезапись шаблона"
                            description="Вы уверены что хотите перезаписать шаблон?"
                            okText="Да"
                            cancelText="Нет"
                            onConfirm={handleUpdateClick}
                            onCancel={onClose}
                        >
                            <div role="button" className="px-4 pb-2 pt-2">
                                Перезаписать шаблон
                            </div>
                        </Popconfirm>
                    </li>
                    <li className="text-red-500">
                        <Popconfirm
                            title="Удаление шаблона"
                            description="Вы уверены что хотите удалить шаблон?"
                            okText="Да"
                            cancelText="Нет"
                            onConfirm={handleRemoveClick}
                            onCancel={onClose}
                        >
                            <div role="button" className="px-4 py-2">
                                Удалить шаблон
                            </div>
                        </Popconfirm>
                    </li>
                </>
            )}
        </ul>
    );
};

interface DropdownMenuProps {
    disabled: boolean;
    onDeleteTemplate: () => void;
    onDefaultClick: () => void;
    onUpdate: () => void;
    isOwner: boolean;
}

export const DropdownMenu: FC<DropdownMenuProps> = ({
    disabled,
    onDeleteTemplate,
    onDefaultClick,
    onUpdate,
    isOwner,
}) => {
    const [visible, setVisible] = useState(false);

    const onVisibleChange = (value: boolean) => setVisible(value);
    const onClose = () => setVisible(false);

    return (
        <Dropdown
            className="ml-auto cursor-pointer"
            placement="bottomRight"
            popupRender={() => (
                <Menu
                    isOwner={isOwner}
                    onClose={onClose}
                    onDelete={onDeleteTemplate}
                    onDefaultClick={onDefaultClick}
                    onUpdate={onUpdate}
                />
            )}
            trigger={['click']}
            open={visible}
            disabled={disabled}
            onOpenChange={onVisibleChange}
        >
            <button className="flex items-center">
                <MoreOutlined className="fill-current text-black dark:text-white" style={{ fontSize: 18 }} />
            </button>
        </Dropdown>
    );
};
